// extracted by mini-css-extract-plugin
export default {"panePlaceholder":"panePlaceholder---fkBNM","appIcon":"appIcon---CWH3r"};